var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { InteractionsServiceConstants } from "@agentx/agentx-services";
import { action, observable } from "mobx";
export class InteractionsStore {
    constructor() {
        this.activeInteractions = [];
        this.queuedInteractions = [];
        this.completedInteractions = [];
    }
    updateSelectedInteraction(interactionId) {
        if (interactionId !== "") {
            const interactions = [...this.activeInteractions, ...this.queuedInteractions, ...this.completedInteractions];
            this.selectedInteraction = interactions.find((interaction) => (interaction === null || interaction === void 0 ? void 0 : interaction.id) === interactionId);
        }
        else {
            this.selectedInteraction = undefined;
        }
    }
    updateInteractions(type, added, updated, removed) {
        switch (type) {
            case InteractionsServiceConstants.QueryType.Active:
                this.activeInteractions = this.getUpdatedInteractionsList(this.activeInteractions, added, updated, removed);
                break;
            case InteractionsServiceConstants.QueryType.Queued:
                this.queuedInteractions = this.getUpdatedInteractionsList(this.queuedInteractions, added, updated, removed);
                break;
            case InteractionsServiceConstants.QueryType.Completed:
                this.completedInteractions = this.getUpdatedInteractionsList(this.completedInteractions, added, updated, removed);
                break;
            default:
                throw new Error(`Unknown interaction type: ${type}`);
        }
    }
    //move to service
    getUpdatedInteractionsList(interactions, added, updated, removed) {
        const filteredInteractions = interactions.filter((interaction) => !removed.find((removedInteraction) => removedInteraction.id === interaction.id));
        return [...filteredInteractions, ...added].map((interaction) => { var _a; return (_a = updated.find((updatedInteraction) => updatedInteraction.id === interaction.id)) !== null && _a !== void 0 ? _a : interaction; });
    }
}
__decorate([
    observable
], InteractionsStore.prototype, "selectedInteraction", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "activeInteractions", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "queuedInteractions", void 0);
__decorate([
    observable
], InteractionsStore.prototype, "completedInteractions", void 0);
__decorate([
    action
], InteractionsStore.prototype, "updateSelectedInteraction", null);
__decorate([
    action
], InteractionsStore.prototype, "updateInteractions", null);
